import React, { useState } from 'react';
import { useLocation } from 'react-router';

import Avatar from '@material-ui/core/Avatar';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import Box from '@material-ui/core/Box';
import LockOutlinedIcon from '@material-ui/icons/LockOutlined';
import Typography from '@material-ui/core/Typography';
import Container from '@material-ui/core/Container';
import { useDialog } from '../../utils/dialog';
import { useAPI } from '../../utils/api';

const validPasswor = (password) => {
  const passworFormat = /^[\dA-Za-z]{6,10}$/;
  return passworFormat.test(password);
};

const ResetPasswordPage = () => {
  const [isPasswordError, setIsPasswordError] = useState(false);
  const [isConfirmPasswordError, setIsConfirmPasswordError] = useState(false);
  const location = useLocation();
  const api = useAPI();
  const dialog = useDialog();

  const useQuery = () => new URLSearchParams(location.search);
  const validToken = useQuery().get('data') || '';

  const submitResetPassword = (event) => {
    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const newPassword = data.get('password');
    const confirmPassword = data.get('confirmPassword');

    if (!validPasswor(newPassword)) {
      setIsPasswordError(true);
    } else if (!(newPassword === confirmPassword)) {
      setIsConfirmPasswordError(true);
    } else {
      const parameters = {
        newPassword,
        confirmPassword,
        validToken,
      };

      api
        .resetPassword(parameters)
        .then(() => {
          dialog.openAlert({
            message: '重設成功，請重新登入。',
            replaceTo: '/login',
          });
        })
        .catch(() => {});
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'center',
        }}
      >
        <Avatar sx={{ m: 1, bgcolor: 'secondary.main' }}>
          <LockOutlinedIcon />
        </Avatar>
        <Typography component="h1" variant="h5">
          重設密碼
        </Typography>
        <Box
          component="form"
          onSubmit={submitResetPassword}
          noValidate
          sx={{ mt: 1 }}
          autoComplete="off"
        >
          <TextField
            id="password"
            name="password"
            label="密碼"
            helperText={
              isPasswordError ? '密碼格式錯誤' : '請輸入6-10個中英文數字'
            }
            type="password"
            margin="normal"
            autoComplete="new-password"
            required
            fullWidth
            onChange={() => setIsPasswordError(false)}
            error={isPasswordError}
          />
          <TextField
            id="confirmPassword"
            name="confirmPassword"
            label="確認密碼"
            helperText={
              isConfirmPasswordError
                ? '兩次輸入的密碼不一致'
                : '請輸入6-10個中英文數字'
            }
            type="password"
            margin="normal"
            autoComplete="new-password"
            required
            fullWidth
            onChange={() => setIsConfirmPasswordError(false)}
            error={isConfirmPasswordError}
          />

          <Button
            type="submit"
            fullWidth
            variant="contained"
            color="success"
            sx={{ mt: 3, mb: 3, color: 'white' }}
          >
            確認送出
          </Button>
        </Box>
      </Box>
    </Container>
  );
};

export default ResetPasswordPage;
